<template >
  <div class="examinDetail" v-if="examinDate">
    <el-dialog title="审批详情" :visible.sync="sta" width="800px" :before-close="cancel">
      <div class="examinDetail_content">
        <div class="top">
<!--          <span class="left">{{examinDate.applyEmployeeName}}的{{examinDate.holidayName}}申请</span>-->
          <span class="left">{{examinDate.applyEmployeeName}}-{{fllterHolidayName(examinDate.holidayName)}}申请</span>
          <!--new-->
          <span v-if="examinDate.applyStatus=='审批拒绝'" style="color:#FF4726;max-width: 430px">{{examinDate.refuseReasons}}</span>
          <span v-if="examinDate.applyStatus=='已撤回'" style="color:#FF4726;max-width: 430px">{{examinDate.withdrawReason}}</span>
          <span class="right"
            :style="examinDate.applyStatus=='审批中'?'color:#FF7000':examinDate.applyStatus=='已撤回'?'color:#999999':examinDate.applyStatus=='无效'?'color:#999999':examinDate.applyStatus=='审批拒绝'?'color:#FF4726':'color:#2CA203'">{{examinDate.applyStatus}}</span>
        </div>
        <!--new-->
        <div>
          <div class="examinDetail_content_item">
<!--            <div class="item" style="width: 180px;">申请人：{{examinDate.applyEmployeeName}}</div>-->
            <div class="item" style="width: 250px;">店组：{{examinDate.storeGroupName}}</div>
            <div class="item"  style="width: 220px;">申请时间：{{examinDate.applyDate}}</div>
<!--            <div class="item" style="width: 180px;">类型：{{examinDate.holidayName}}</div>-->
            <div class="item" style="width: 180px;">类型：{{examinDate.houseBusinessTypeName || examinDate.holidayName}}</div>
          </div>
          <!--请假-->
          <div v-if="examinDate.businessType==null">
            <div class="examinDetail_content_item">
              <div class="item">请假时间：{{examinDate.beginDatetime}} ~ {{examinDate. endDatetime}}</div>
              <div class="item" style="width: 180px;">时长：{{examinDate.holidayNumber}}小时</div>
            </div>
          </div>
          <!--外勤-->
          <div v-if="examinDate.businessType=='field'">
            <div class="examinDetail_content_item">
              <div class="item">外勤时间：{{examinDate.beginDatetime.split(' ')[0]+ ' ' +examinDate.repairCardTime}}</div>
            </div>
          </div>
          <!--补卡-->
          <div v-if="examinDate.businessType=='card'">
            <div class="examinDetail_content_item">
              <div class="item">补卡时间：{{examinDate.beginDatetime.split(' ')[0]+ ' ' +examinDate.repairCardTime}}</div>
            </div>
          </div>
          <!--房源-->
          <div
               v-if="['whether_house','whether_key','whether_exploration','whether_house_look',
               'whether_house_update','house_update_option','whether_twoHandhouse'
               ,'whether_renthouse','whether_shoptrade','whether_shoprent'
               ].includes(examinDate.businessType)"

          >
            <div class="examinDetail_content_item">
              <div class="item" style="width: 250px;">房源编号：<span style="color: #5E75E6;cursor: pointer" @click="toHouse">{{examinDate.houseCode}}</span></div>
              <div class="item" style="width: 220px;">来源：{{examinDate.sourceName}}</div>
              <div class="item" style="width: 180px;">房源级别：{{examinDate.houseLevel}}</div>
            </div>
            <!--钥匙-->
            <div class="examinDetail_content_item" v-if="examinDate.businessType=='whether_key'">
              <div class="item" style="width: 180px;">钥匙编号：{{examinDate.keyCode}}</div>
              <div class="item" style="width: 220px;">收钥匙时间：{{examinDate.submissionDate}}</div>
              <div class="item" style="width: 180px;">存放门店：{{examinDate.storeName}}</div>
            </div>
            <!--录入带看-->
            <div class="examinDetail_content_item" v-if="examinDate.businessType=='whether_house_look'">
              <div class="item" style="width: 180px;">带看客源：<span style="color: #5E75E6;cursor: pointer" @click="toCustomer">{{examinDate.cusCode}}</span></div>
              <div class="item" style="width: 220px;">带看时间：{{examinDate.lookTime}}</div>
              <div class="item" style="width: 180px;">客户等级：{{examinDate.customerLevel}}</div>
            </div>
            <div class="item">房源地址：{{examinDate.houseAddress}}</div>
          </div>
          <!--客源-->
          <div v-if="examinDate.businessType=='whether_customer'||
                     examinDate.approvalType=='whether_rentcustomer'||
                     examinDate.approvalType == 'whether_buycustomer'
  ">
            <div class="examinDetail_content_item">
              <div class="item" style="width: 180px;">客源编号：<span style="color: #5E75E6;cursor: pointer" @click="toCustomer">{{examinDate.cusCode}}</span></div>
              <div class="item" style="width: 220px;">客户姓名：{{examinDate.customerName}}</div>
              <div class="item" style="width: 180px;">客源级别：{{examinDate.customerLevel}}</div>
            </div>
          </div>
          <!--黑名单-->
          <div v-if="examinDate.businessType=='whether_black'">
            <div class="examinDetail_content_item">
              <div class="item" style="width: 180px;">黑名单编号：{{examinDate.blackId}}</div>
              <div class="item" style="width: 220px;">黑名单电话：{{examinDate.blackPhone}}</div>
              <div class="item" style="width: 180px;">黑名单备注：{{examinDate.blackRemark}}</div>
            </div>
          </div>
        </div>
        <!--old-->
        <div v-if="false">
          <div class="item" >申请人：{{examinDate.applyEmployeeName}}</div>
          <div class="item" >申请时间：{{examinDate.applyDate}}</div>
          <div class="item">类型：{{examinDate.holidayName}}</div>
          <div class="item">请假时间：{{examinDate.beginDatetime}} ~ {{examinDate. endDatetime}}</div>
          <div class="item">时长：{{examinDate.holidayNumber}}小时</div>
        </div>
        <div class="item"
             v-if="['whether_twoHandhouse','whether_renthouse','whether_shoptrade','whether_shoprent','whether_rentcustomer','whether_buycustomer'].includes(examinDate.approvalType)"

            >变更属性：{{examinDate.jsonString}}</div>

        <div class="item">详情：{{examinDate.applyDemo}}</div>

        <div class="item" v-if="examinDate.url">
          <span class>图片:</span>
          <img @click="maskShow=true" :src="'http://'+examinDate.url" alt />
        </div>
        <div class="title" style="border-top: 1px solid #E1E1E1;padding-top: 20px;">审批明细</div>
        <div class="list" v-for="(item,index) in examinDate.list" :key="index">
          <div class="list1">
            <div class="list_item" v-for="(child,index) in item.list" :key="index">
              <img class="avatar" v-if="child.photo" :src="'http://'+child.photo" alt />
              <img class="avatar" v-else src="../../../assets/images/timgs.png" alt />
              <div>
                <p>
                  {{child.name}}
                  <span v-if="child.checkStatus!='审批中'"
                    :style="child.checkStatus=='审批同意'?'color:#2CA203':'color:#FF4726'">({{child.checkStatus}})</span>
                </p>
                <p>{{child.roleName}}</p>
              </div>
              <div v-if="child.checkStatus!='审批中'">
                <p>审批时间：{{child.checkDate}}</p>
                <p>审批意见：{{child.checkRemak}}</p>
              </div>
              <i v-if="index!=item.list.length-1" class="el-icon-plus"></i>
            </div>
          </div>
          <i v-if="index!=examinDate.list.length-1" class="iconfont1 el-icon-bottom"></i>
        </div>
      </div>
      <div class="dialog-foot" >
        <!--new-->
        <button v-points class="foot-cancel" style="background: #00C473" @click="dialogVisible=true;checkDemo1=''" v-if="examinDate.whetherWithDraw">撤回</button>
        <button v-points class="foot-cancel" v-if="examinDate.whetherCheck" @click="dialogsta=true;checkDemo=''">拒绝</button>
        <button v-points class="foot-save" v-if="examinDate.whetherCheck" @click="save('AUDITED')">同意</button>
      </div>
    </el-dialog>

    <el-dialog :visible.sync="dialogsta" v-if="dialogsta" title="审批意见" width="620px">
      <div class="examinDetail_content">
        <div class="item">
          <div style="min-width:85px">类型：</div>{{examinDate.holidayName}}
        </div>
        <div class="item">
          <div style="min-width:85px"><span style="color:red;">*</span>审批意见：</div>

          <el-input type="textarea" :autosize="{ minRows: 2, maxRows: 4}" placeholder="请输入内容" v-model="checkDemo">
          </el-input>
        </div>
      </div>
      <div class="dialog-foot">
        <button class="foot-cancel" @click="dialogsta=false">取消</button>
        <button v-points class="foot-save" @click="save('UNABLE')">确定</button>
      </div>
    </el-dialog>

    <!--理由-->
    <el-dialog title="撤回原因" :visible.sync="dialogVisible" width="400px">
      <el-input style="margin:20px 30px;width: 350px;" type="textarea" :rows="4" placeholder="请输入内容" v-model="checkDemo1"></el-input>
      <div class="dialog-foot">
        <el-button class="foot-cancel" @click="dialogVisible = false">取 消</el-button>
        <el-button class="foot-save" v-points type="primary" @click="withdrawApply">确 定</el-button>
      </div>
    </el-dialog>

    <maskComponent v-if="maskShow" @closeMask="maskShow=false" :imgListProp="examinDate.url" />

  </div>
</template>

<script>
import { queryCostDetail, updateStatus } from "@/api/checkingIn";
import {withdrawApply} from '@/api/approveManage'
import maskComponent from "@/components/common/maskComponent";
export default {
  components: {
    maskComponent
  },
  props: {
    sta: false,
    examinId: "",
  },
  data() {
    return {
      dialogVisible:false,
      examinDate: {},
      checkDemo: "",
      checkDemo1: "",
      dialogsta: false,
      maskShow: false
    };
  },

  mounted() {
    console.log(111111111, this.sta);
    if (this.examinId) {
      this.queryCostDetail(this.examinId);
    }
  },

  methods: {
    fllterHolidayName(e) {
      return e.split('-')[1];
    },
    //撤回
    withdrawApply(){
      if (!this.checkDemo1) {
        this.$message.error('请填写撤回理由');
        return;
      }
      let params = {
        applyId:this.examinDate.id,
        checkDemo:this.checkDemo1
      };
      this.$post(withdrawApply,params).then(res=>{
        if (res.success){
          this.$message.success(res.msg);
          this.cancel();
        } else {
          this.$message.error(res.msg);
        }
      })
    },
    toHouse(){
      if (this.examinDate.businessStatus=='DELETE'){
        this.$message.error('该关联业务已删除');
      } else{
        if (this.examinDate.houseBusinessType==='SHOP_SALE') {
          //商铺买卖
          sessionStorage.setItem("buildId", this.examinDate.houseId);
          sessionStorage.setItem("sellShopbuildId", this.examinDate.houseId);
          this.$store.state.houseType = "SHOP_SALE";
          this.$router.push('/sellShopDetails')
        }else if (this.examinDate.houseBusinessType==='SHOP_RENTAL') {
          //商铺租赁
          sessionStorage.setItem("buildId", this.examinDate.houseId);
          sessionStorage.setItem('rentShopbuildId',this.examinDate.houseId);
          this.$store.state.houseType = "SHOP_RENTAL";
          this.$router.push('/rentShopDetails')
        }else if (this.examinDate.houseBusinessType==='SECONDHAND') {
          //二手房
          sessionStorage.setItem("buildId", this.examinDate.houseId);
          sessionStorage.setItem("sellHousebuildId",this.examinDate.houseId);
          this.$store.state.houseType = "SECONDHAND";
          this.$router.push('/buildDetail')
        }else if (this.examinDate.houseBusinessType==='RENTING') {
          //租房
          sessionStorage.setItem("buildId", this.examinDate.houseId);
          sessionStorage.setItem('rentHousebuildId',this.examinDate.houseId);
          this.$store.state.houseType = "RENTING";
          this.$router.push('/rentingBuildDetail')
        }
        this.cancel();
      }

    },
    toCustomer(){
      if (this.examinDate.businessStatus=='DELETE'){
        this.$message.error('该关联业务已删除');
      }else {
        if (this.examinDate.customerBusinessType==='WANT_TO_BUY') {
          //客源求购
          localStorage.setItem("customerId", this.examinDate.customerId);
          localStorage.setItem('ketype',this.examinDate.customerBusinessType);
          this.$router.push('/purchaseDetail')
        }else if (this.examinDate.customerBusinessType==='WANT_TO_RENT') {
          //客源求租
          localStorage.setItem("customerId", this.examinDate.customerId);
          localStorage.setItem('ketype',this.examinDate.customerBusinessType);
          this.$router.push('/purchaseDetail')
        }
        this.cancel();
      }

    },
    cancel() {
      this.$emit("cancel", false);
    },

    queryCostDetail(id) {
      let params = {
        id: id
      };
      this.$post(queryCostDetail, params).then(res => {
        if (res.success) {
          this.examinDate = res.data;
        }
      });
    },

    save(data) {
      let params = {
        applyId: this.examinDate.id,
        checkId: this.examinDate.nextCheckId,
        checkStatus: data,
        checkDemo: this.checkDemo

      };
      this.$post(updateStatus, params).then(res => {
        if (res.success) {
          this.$message.success(res.msg);
          this.cancel();
        } else {
          this.$message.error(res.msg);
        }
      });
    }
  }
};
</script>

<style lang="less">
.examinDetail {
  .el-dialog {
    .el-dialog__header {
      padding: 20px 30px 0 30px;
    }
    .el-dialog__body {
      .examinDetail_content {
        padding: 20px 30px 20px 30px;
        max-height: 700px;
        overflow-y: auto;
        .top {
          display: flex;
          align-items: center;
          justify-content: space-between;
          padding-bottom: 20px;
          .left {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: bold;
            color: rgba(51, 51, 51, 1);
          }
          .right {
            font-size: 16px;
            font-family: Microsoft YaHei;
            font-weight: 400;
          }
        }
        .item {
          display: flex;
          align-items: top;
          justify-content: flex-start;
          font-size: 14px;
          color: #606266;
          padding-bottom: 18px;
          img {
            width: 80px;
            height: 70px;
            margin-left: 10px;
          }
        }
        .title {
          font-size: 16px;
          font-family: Microsoft YaHei;
          font-weight: bold;
          color: rgba(51, 51, 51, 1);
          padding-bottom: 20px;
        }
        .list {
          font-size: 14px;
          .iconfont1 {
            font-size: 30px;
            color: #cccccc;
            padding: 5px 4px;
          }
          .list1 {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            flex-wrap: wrap;
          }
          &_item {
            display: flex;
            align-items: center;
            justify-content: flex-start;
            padding: 0 3px;
            .avatar {
              width: 40px;
              height: 40px;
              border-radius: 50%;
            }
            > div {
              margin-left: 30px;
              margin-top: 10px;
              font-family: Microsoft YaHei;
              min-width: 80px;
              font-weight: 400;
              color: rgba(96, 98, 102, 1);
              > p {
                padding: 3px 0;
              }
            }
          }
        }
        &_item{
          display: flex;
          justify-content: space-between;
        }
      }
      .dialog-foot {
        text-align: right;
        margin-top: 50px;
        background: #f5f5f5;
        padding: 20px;
        .foot-cancel,
        .foot-save {
          width: 80px;
          height: 40px;
          border: none;
          outline: none;
          border-radius: 4px;
          font-size: 16px;
          color: #ffffff;
          margin-right: 20px;
        }
        .foot-cancel {
          background: #ff4726;
        }
        .foot-save {
          background: #5e75e6;
        }
      }
    }
  }
}
</style>